import React from 'react';
import auth from '../../../../common/utility/auth';
import { Table, Empty, Button, Input, Checkbox, Form, Tooltip, DatePicker, Icon, Select } from 'antd';
import { FORMAT_2DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';
import moment from 'moment';
import { LOGISTICA_PRODUCTOS_CON_LOTE, SERIE_POR_PRODUCTO } from '../../../../common/types/parametroType'

const { Option } = Select;

export default function DetalleProductoServicioModal(props) {
    const mostrarLoteProducto = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
    const seriePorProducto = auth.user().parametros.filter(m => m.abreviatura === SERIE_POR_PRODUCTO)[0].valor === "1" ? true : false;

    return (
        <div>
            <Table
                className={'table-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 40,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        key: 'asignar-serie-button',
                        align: 'center',
                        width: (seriePorProducto) ? 90 : 0,
                        fixed: 'left',
                        render: (value, row) => (

                            <span>
                                <div className="custom-options" hidden={seriePorProducto ? false : true}>
                                    <Tooltip placement="top" title="Buscar Serie">
                                        <Button
                                            type="primary"
                                            icon="bars"
                                            size={"small"}
                                            disabled={row.flagAplicarSerie ? false : true}
                                            onClick={() => props.onAgregarSerie(row, props.onCalculateDetail, props.onSetFieldsValue, props.onGetFieldValue)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Código',
                        dataIndex: 'codigo',
                        key: 'codigo',
                        align: 'center',
                        width: 80,
                        ellipsis: true,
                        fixed: 'left',
                    },
                    {
                        title: 'Nombre',
                        dataIndex: 'nombre',
                        key: 'nombre',
                        width: 300,
                        ellipsis: true,
                        fixed: 'left',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    <Tooltip placement="top" title={value}>
                                        {
                                            props.onGetFieldDecorator(`arrNombre[${row.nombre}]`, {
                                                initialValue: value
                                            })(
                                                <Input
                                                    placeholder="Nombre"
                                                    autoComplete="off"
                                                    className="text-left"
                                                    readOnly={true}
                                                    onClick={(e) => props.onChangeNameProduct(row)}
                                                />
                                            )
                                        }
                                    </Tooltip>
                                </Form.Item>
                            )
                        }
                    },
                    {
                        title: (seriePorProducto) ? 'Series' : '',
                        dataIndex: 'detalleSeries',
                        key: 'detalleSeries',
                        width: (seriePorProducto) ? 90 : 0,
                        ellipsis: true,
                        render: (value, row) => {
                            return (
                                <div className={row.flagAplicarSerie ? '' : 'hide'}
                                    onClick={() => props.onAgregarSerie(row, props.onCalculateDetail, props.onSetFieldsValue, props.onGetFieldValue)}
                                >
                                    {props.onGetFieldDecorator(`arrDetalleSeries[${row.identifier}]`, { initialValue: value })(
                                        <Input
                                            readOnly
                                            title={props.onGetFieldValue(`arrDetalleSeries[${row.identifier}]`)}
                                            style={{ cursor: 'pointer', border: '1px solid #ffffff' }}

                                        />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'nombreUnidadMedida',
                        key: 'nombreUnidadMedida',
                        width: 100,
                        ellipsis: true
                    },

                    {
                        title: mostrarLoteProducto === false ? '' : 'Lote',
                        width: mostrarLoteProducto === false ? 0 : 90,
                        dataIndex: 'lote',
                        key: 'lote',
                        align: 'center',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrLote[${row.identifier}]`, {
                                        initialValue: value,
                                        rules: [{
                                            required: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Lote"
                                            autoComplete="off"
                                            className="text-left"
                                            disabled
                                            onBlur={(e) => props.onCalculateDetail(row, "arrLote", e.target.value, 0)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: mostrarLoteProducto === false ? '' : 'Fecha Vcto.',
                        width: mostrarLoteProducto === false ? 0 : 100,
                        dataIndex: 'fechaVencimiento',
                        key: 'fechaVencimiento',
                        align: 'center',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrfechaVencimiento[${row.identifier}]`, {
                                        initialValue: value,
                                        rules: [{
                                            required: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="fechaVencimiento"
                                            autoComplete="off"
                                            className="text-left"
                                            disabled
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Valor Unitario',
                        dataIndex: 'precioUnitario',
                        key: 'precioUnitario',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecioUnitario[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            // disabled={props.precioUnitarioDisabled}
                                            placeholder="P.  Unitario"
                                            disabled={true}
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, row.idProducto, "arrPrecioUnitario", e.target.value, 5)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Tipo IGV',
                        dataIndex: 'idImpuesto',
                        key: 'idImpuesto',
                        width: 220,
                        ellipsis: true,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arridImpuesto[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(

                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo IGV"}
                                            optionFilterProp="children"
                                            onChange={(option) => { props.onCalculateDetail(row, row.idProducto, "arridImpuesto", option.key, 5); }}
                                        >
                                            {props.tipoAfectacion.map(item => (
                                                ['10', '20', '30', '40'].includes(item.codigoSunat) ?
                                                    <Option key={item.id} value={item.id}>{item.nombre}</Option> :
                                                    null
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Tooltip title={`Stock Disponible: ${row.stock.toFixed(2)}`}>
                                    <Form.Item>
                                        {props.onGetFieldDecorator(`arrCantidad[${row.identifier}]`, {
                                            initialValue: parseFloat(value).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(GREATER_THAN_ZERO),
                                                message: "Formato (0.00)"
                                            }]
                                        })(
                                            <Input
                                                disabled={row.flagAplicarSerie ? true : false}
                                                placeholder="Cantidad"
                                                autoComplete="off"
                                                className="text-right"
                                                onBlur={(e) => props.onCalculateDetail(row, row.idProducto, "arrCantidad", e.target.value, 3)}
                                            />
                                        )}
                                    </Form.Item>
                                </Tooltip>
                            );
                        }
                    },
                    {
                        title: 'Sub Total',
                        dataIndex: 'subTotal',
                        key: 'subTotal',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrSubTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'IGV',
                        dataIndex: 'igv',
                        key: 'igv',
                        align: 'center',
                        width: 80,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrIgv[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'Total',
                        dataIndex: 'total',
                        key: 'total',
                        fixed: 'right',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            disabled={true}
                                            //disabled={props.totalDisabled}
                                            placeholder="Total"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrTotal", e.target.value, 2)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    }
                ]}
            />
        </div>
    );
}